import { render, staticRenderFns } from "./cases.vue?vue&type=template&id=32e1abeb&scoped=true&"
import script from "./cases.vue?vue&type=script&lang=js&"
export * from "./cases.vue?vue&type=script&lang=js&"
import style0 from "./cases.vue?vue&type=style&index=0&id=32e1abeb&lang=scss&scoped=true&"
import style1 from "./cases.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e1abeb",
  null
  
)

export default component.exports